import React from "react";
import { Redirect, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";

import { GET_SPECIAL_PACK_EDITION_DETAILS } from "../../graphql/queries";
import { dateDiff, dateDuration, parseDate } from "../../helpers/dates";
import { logError } from "../../helpers/logging";
import urlPatterns from "../../urls";
import { REGISTER_INTEREST_DURATION_MONTHS } from "../../helpers/constants";
import StyledLoading from "../../components/atoms/Loading/StyledLoading";
import { SpecialPackEdition } from "../../types/__generated__/SpecialPackEdition";
import SpecialBoxInfoController from "../../components/organisms/SpecialBoxInfo/controller";

const SpecialPackDetails = () => {
  const { slug } = useParams<{ slug: string }>();

  const {
    data: specialPackEditionDetailsData,
    loading: isSpecialPackEditionDetailsQueryLoading,
    error: specialPackEditionDetailsQueryError,
  } = useQuery<SpecialPackEdition>(GET_SPECIAL_PACK_EDITION_DETAILS, {
    variables: { slug },
  });

  const isLoading = isSpecialPackEditionDetailsQueryLoading;

  /**
   * Checks if the page should redirect the user back to listing page.
   *
   * @returns {boolean}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const shouldRedirectToListingPage = (endDate: any) => {
    const parsedEndDate = parseDate(endDate);
    const nowDate = parseDate();
    const interval = dateDuration(dateDiff(nowDate, parsedEndDate));
    // @ts-ignore
    return interval.asMonths() > REGISTER_INTEREST_DURATION_MONTHS;
  };

  if (isLoading) {
    return <StyledLoading />;
  }

  if (specialPackEditionDetailsQueryError)
    logError(specialPackEditionDetailsQueryError, {
      location: "SpecialPackDetails",
      action: "GET_SPECIAL_PACK_EDITION_DETAILS",
    });

  const specialPackEdition = specialPackEditionDetailsData?.specialPackEdition;

  if (!specialPackEdition) {
    return <Redirect to={urlPatterns.NOT_FOUND} />;
  }

  const { endDate } = specialPackEdition ?? {};
  if (endDate && shouldRedirectToListingPage(endDate)) {
    return <Redirect to={urlPatterns.SPECIAL_PACKS} />;
  }

  return <SpecialBoxInfoController specialPackEdition={specialPackEdition} />;
};

export default SpecialPackDetails;
